import React, { useState } from 'react';
import { handlePointerDown} from '../../lib/modal-helper';
import { selectAllStrings } from '../language/languageSlice';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { addNewTrial, checkEmail } from '../user/userSlice';
import { unwrapResult } from '@reduxjs/toolkit';
import ErrorMessage from '../../app/ErrorMessage';
import { getUdid } from '../../api/mobile';

const InsertMailModal = ({onGoAhead}) => {
    const strings = useSelector(selectAllStrings);
    const [email, setEmail] = useState('');
    const [insertRequestStatus, setInsertRequestStatus] = useState('idle');
    const [error, setError] = useState('');

    const dispatch = useDispatch();

    const onEmailChanged = (event) => setEmail(event.target.value);

    const canContinue = email && insertRequestStatus === 'idle';

    const onContinueClicked = async (event) => {
        event.preventDefault();
        if (canContinue) {
            try {
                let resultAction;
                setInsertRequestStatus('pending');
                resultAction = await dispatch(checkEmail(email));
                unwrapResult(resultAction);
                if (resultAction.payload.status == 1) {
                    const udid = await getUdid();
                    resultAction = await dispatch(
                            addNewTrial({email, udid})
                            );

                    unwrapResult(resultAction);

                    if (resultAction.payload.status == 1) {
                        onGoAhead();
                        return;
                    } else {
                        setError(resultAction.payload.msg);
                        setEmail('');
                    }
                } else {
                    setError(resultAction.payload.msg);
                    setEmail('');
                }
            } catch (err) {
                setError(err.message);
                setInsertRequestStatus('failed');
            } finally {
                setInsertRequestStatus('idle');
            }
        }
    };
    const history = useHistory();

    return (error ? <ErrorMessage strings={strings} message={error} onGoBack={() => setError('')} /> :
            <div className="modal" id="insert_mail_modal">
                <div className="modal-body" id="insert_mail_modal_body">
                    <div className="modal-border" onPointerDown={event => handlePointerDown(event, 'insert_mail_modal_body')}>
                        <div className="move-handler"></div>
                    </div>
                    <div className="modal-content">
                        <div className="modal-header" onPointerDown={event => handlePointerDown(event, 'insert_mail_modal_body')}>
            
                            <a className="close-modal" onPointerDown={event => {
                                    event.preventDefault();
                                    event.stopPropagation();
                                   }} onClick={event => {
                                       event.preventDefault();
                                       history.push('/');
                                   }}></a>
                            <span onPointerDown={event => event.preventDefault()}>{strings.free_trial}</span>
                            <hr/>
                        </div>
                        <div className="modal-title">{strings.activate}</div>
                        <div className="modal-text">{strings.you_can_use}</div>
                        <form>
                            <label>{strings.insert_email}
                                <input type="text" id="email" placeholder={strings.email} required value={email} onChange={onEmailChanged}/>
                            </label>
                            <button type="submit" className="btn" id="continue_button" onClick={onContinueClicked} disabled={!canContinue}>
                            {insertRequestStatus === 'pending' ? <div className="loader"></div> : strings.continue}
                            </button>
                        </form>
                    </div>
                </div>
            </div>);
};

export default InsertMailModal;

